import DocumentEvaluationUpdater, {EvaluationOptions} from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';
import {BioentityNote} from 'notebook/util/NoteUtilConstants';

export default class BioentityNoteUpdater extends DocumentEvaluationUpdater<BioentityNote, BioentityNote> {
  getDoc(root: BioentityNote): BioentityNote {
    return root;
  }

  traverse(
    evalTraverser: DocumentTraverser,
    newDoc: BioentityNote,
    oldDoc: BioentityNote | null,
    opts?: EvaluationOptions
  ): void {
    evalTraverser.walkBioentityNote(newDoc, oldDoc, opts);
  }

  mapDoc(mapper: DocumentMapper, doc: BioentityNote): BioentityNote {
    return mapper.mapBioentityNote(doc, null);
  }

  updatedRoot(root: BioentityNote, doc: BioentityNote): BioentityNote {
    return doc;
  }
}
